module.exports = __webpack_public_path__ + "img/img39.660521d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img39.jpg
// module id = 337
// module chunks = 0